import { motion } from 'framer-motion';

export default function PrivacyPolicyPage() {
  return (
    <div className="pt-20" data-testid="privacy-policy-page">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-[#374151] mb-4">
              Privacy Policy
            </h1>
            <p className="text-gray-500">
              Your privacy is important to us
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="prose prose-lg max-w-none"
          >
            <p className="text-gray-600 leading-relaxed mb-8">
              At Loans and Beyond we are committed to protecting your privacy in accordance with the Privacy Act 1998 (Cth). This Privacy Policy describes our current policies and practices in relation to the handling and use of personal information.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#374151] mt-10 mb-4">
              What information do we collect and how do we use it?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              When we arrange finance on your behalf, we ask you for the information we need to advise you about your finance needs and your borrowing capacity. We provide any information that the lenders to whom we apply on your behalf require to enable them to decide whether to lend to you and on what terms.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              We also use your information to enable us to manage your ongoing requirements, e.g. refinancing, and our relationship with you, e.g. invoicing, client surveys etc. We may do so by mail or electronically unless you tell us that you do not wish to receive electronic communications.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              We may occasionally notify you about new services and special offers, events or articles we think will be of interest to you. We may send you regular updates by email or by post on finance matters. If you would rather not receive this information, please email or write to us.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              We may also use your information internally to help us improve our services and help resolve any problems.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#374151] mt-10 mb-4">
              What if you don't provide some information to us?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              We can only fully advise you about your borrowing capacity and the suitability of a loan if we have all relevant information.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#374151] mt-10 mb-4">
              How do we hold and protect your information?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              We strive to maintain the reliability, accuracy, completeness and currency of the personal information we hold and to protect its privacy and security. We keep personal information only for as long as is reasonably necessary for the purpose for which it was collected or to comply with any applicable legal or ethical reporting or document retention requirements.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              We hold the information we collect from you in electronic form on our cloud storage. We ensure that your information is safe as we have passwords in place for secure access. This information may be held by us in electronic form on our secure servers and may also be held in paper form.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              We may use cloud storage or other types of networked or electronic storage to store the information we hold about you. As electronic or networked storage can be accessed from various countries via an internet connection, it is not always practicable to know in which country your information may be held. If your information is stored in this way, disclosures may occur in countries other than those listed.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Overseas organisations may be required to disclose information we share with them under a foreign law. We are not responsible for such disclosure.
            </p>

            <div className="mt-12 p-6 bg-gray-50 rounded-xl">
              <p className="text-gray-500 text-sm">
                If you have any questions about our Privacy Policy, please contact us at{' '}
                <a href="mailto:Jyotsna@loansandbeyond.com" className="text-[#6B7280] hover:underline">
                  Jyotsna@loansandbeyond.com
                </a>
                {' '}or{' '}
                <a href="mailto:Nidhi@loansandbeyond.com" className="text-[#6B7280] hover:underline">
                  Nidhi@loansandbeyond.com
                </a>
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
